module.exports = __webpack_public_path__ + "static/img/8.1c301e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/8.png
// module id = uQGe
// module chunks = 10